import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import Button from 'components/Button';
import Panel from 'components/Panel';
import ModalHeadline from 'components/ModalHeadline';
import AuthPageWrapper from './shared/AuthPageWrapper';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
function ForgotPasswordConfirmation() {
  var _useTranslation = useTranslation(),
    _useTranslation2 = _slicedToArray(_useTranslation, 1),
    t = _useTranslation2[0];
  return /*#__PURE__*/_jsxs(AuthPageWrapper, {
    children: [/*#__PURE__*/_jsx(ModalHeadline, {
      title: t('forgot_pw_success_title')
    }), /*#__PURE__*/_jsx(Panel, {
      children: /*#__PURE__*/_jsx("p", {
        children: t('forgot_pw_success_description')
      })
    }), /*#__PURE__*/_jsx(Panel, {
      align: "center",
      children: /*#__PURE__*/_jsx(Button, {
        as: Link,
        to: "/login",
        variant: "primary",
        children: t('back_to_login')
      })
    })]
  });
}
export default ForgotPasswordConfirmation;